export enum GlobalSocketEventType {
  Connection = 'connection',
  Disconnect = 'disconnect',
  Disconnecting = 'disconnecting',
  Ping = 'ping',
  Pong = 'pong',
  ConnectedClientsCount = 'connected-clients-count',
  JoinResource = 'join-resource',
  LeaveResource = 'leave-resource',
  UserJoinedResource = 'user-joined-resource',
  UserLeftResource = 'user-left-resource',
  ResourceAccessRevoked = 'resource-access-revoked',
  ResourcePermissionsChanged = 'resource-permissions-changed',
  WorkspaceMemberDeleted = 'workspace-member-deleted',
  UsersInResource = 'user-ids-in-resource',
  NotificationCreated = 'notification-created',
  NotificationsSeen = 'notifications-seen',
  NotificationRead = 'notification-read',
  CallInviteCreated = 'call-invite-created',
  CallInviteUpdated = 'call-invite-updated',
  UserLiveDataInResource = 'user-live-data-in-resource',
  SendUserLiveDataInResource = 'send-user-live-data-in-resource',
  UserUpdated = 'user-updated',
  ResourceLastActivityChange = 'resource-last-activity-change',
  ResourceReadAtChange = 'resource-read-at-change',
  ResourceArchivedAtChange = 'resource-archived-at-change',
  DirectConversationNameChanged = 'direct-conversation-name-changed',
  CellCommentsReadAtChange = 'cell-comments-read-at-change',
  ConversationReadStateChanged = 'conversation-read-state-changed',
  TokenExpired = 'token-expired',
  ActivityItemRestored = 'activity-item-restored',
  TokenAboutToExpire = 'token-about-to-expire',
  ResendToken = 'resend-token',
  DeploymentVersionPublished = 'deployment-version-published',
  AutomationConnectionCallbackUpdated = 'automation-connection-callback-updated',
  NotificationUpdated = 'notification-updated',
  NotificationGroupUpdated = 'notification-group-updated',
  ResourceWatchToggled = 'resource-watch-toggled',
  FavouriteStarsChanged = 'favourite-stars-changed',
  NotificationsRead = 'notifications-read',
  BusyDeferredNotificationsDelivered = 'busy-deferred-notifications-delivered',
  MessageTokenStream = 'message-token-stream',
  CallAgentStateUpdated = 'call-agent-state-updated',
  CallRecordingUpdated = 'call-recording-updated',
  UsageEventCreated = 'usage-event-created',
  SystemMessageCreated = 'system-message-created',
  SystemMessageDeleted = 'system-message-deleted',
  ResourceSpaceCreated = 'resource-space-created',
  SkillChanged = 'skill-changed',
  AgentChanged = 'agent-changed',
  ResourceSpaceUpdated = 'resource-space-updated',
  ResourceSpaceDeleted = 'resource-space-deleted',
  CollectionItemCreated = 'collection-item-created',
  CollectionItemUpdated = 'collection-item-updated',
  CollectionItemDeleted = 'collection-item-deleted',
  CollectionItemsReordered = 'collection-items-reordered',
  MinimizedItemCreated = 'minimized-item-created',
  MinimizedItemUpdated = 'minimized-item-updated',
  MinimizedItemDeleted = 'minimized-item-deleted',
  MinimizedItemsReordered = 'minimized-items-reordered',
  SubscribeJob = 'subscribe-job',
  UnsubscribeJob = 'unsubscribe-job',
  JobProgressUpdated = 'job-progress-updated',
  TemplateImportProgress = 'template-import-progress',
  WhiteboardUpdated = 'whiteboard-updated',
  WhiteboardElementsChanged = 'whiteboard-elements-changed',
  SendConversationTyping = 'send-conversation-typing',
  ConversationTypingChanged = 'conversation-typing-changed',
  /** T-336: the outcome of a `reschedule` or `reschedule/undo` job, to its author only (carries the `requestId`). */
  DatabaseItemsRescheduled = 'database-items-rescheduled',
  DashboardUpdated = 'dashboard-updated',
}
